module.exports = __webpack_public_path__ + "img/cpfl1.104897d1.png";